import { render, staticRenderFns } from "./shootCard.vue?vue&type=template&id=554dc637&scoped=true&"
import script from "./shootCard.vue?vue&type=script&lang=js&"
export * from "./shootCard.vue?vue&type=script&lang=js&"
import style0 from "./shootCard.vue?vue&type=style&index=0&id=554dc637&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554dc637",
  null
  
)

export default component.exports